// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/activeContractIcon2.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Active" aria-label="Active" />;
}
